import { useTranslation } from 'react-i18next';

import { displayName, toAge } from '@virtual-care/isomorphic';

import type { requiresAuth } from '../auth-loader.ts';

interface PatientInfo {
  patientName?: string;
  patientBirthDate?: string;
  patientGender?: string;
  guestEmail?: string;
}

export function useBookingDetails(
  identity: Awaited<ReturnType<typeof requiresAuth>>,
  serviceName: string,
  patientInfo?: PatientInfo,
) {
  const { t } = useTranslation();
  const details: Record<string, any> = {};

  if (patientInfo?.patientName) {
    details[t('common.patientName')] = patientInfo.patientName;
  } else {
    details[t('common.name')] = displayName(identity);
  }

  details[t('common.service')] = serviceName;

  if (patientInfo?.patientBirthDate) {
    details[t('common.age')] =
      toAge({ birthDate: patientInfo.patientBirthDate }) ??
      t('common.notSpecified');
  } else if (identity.b2cProfile) {
    details[t('common.age')] =
      toAge(identity.b2cProfile) ?? t('common.notSpecified');
  }

  if (patientInfo?.patientGender) {
    details[t('common.gender')] = t(`common.${patientInfo.patientGender}`);
  } else if (identity.b2cProfile) {
    details[t('common.gender')] = t(`common.${identity.b2cProfile.gender}`);
  }

  if (patientInfo?.guestEmail) {
    details[t('common.email')] = patientInfo.guestEmail;
  }

  return details;
}
